import type {IconName} from '@wandb/components';
import {Icon} from '@wandb/components';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {
  Button,
  Disclosure,
  DisclosurePanel,
  Heading,
} from 'react-aria-components';

type WBAgentDisclosureProps = React.PropsWithChildren<{
  icon: IconName;
  label: string;
  defaultExpanded?: boolean;
}>;

export function WBAgentDisclosure({
  icon,
  label,
  defaultExpanded = false,
  children,
}: WBAgentDisclosureProps) {
  return (
    <Disclosure
      defaultExpanded={defaultExpanded}
      className="flex flex-col gap-8 group/disclosure">
      <Heading className="m-0">
        <Button
          slot="trigger"
          className="flex w-full gap-8 items-center bg-transparent cursor-pointer text-moon-800">
          <Icon icon={icon} size="sm" />
          <span className="text-left leading-[21px] font-semibold text-sm">
            {label}
          </span>
          <span className="inline-flex rotate-0 transition-[rotate] duration-[220ms] group-data-[expanded]/disclosure:rotate-90">
            <Icon icon="chevron-next" size="sm" />
          </span>
        </Button>
      </Heading>
      <DisclosurePanel className="h-[--disclosure-panel-height] overflow-clip transition-[height] duration-200">
        {children}
      </DisclosurePanel>
    </Disclosure>
  );
}
